import $ from 'jquery';
import _ from 'underscore';
import { getStorage } from '../../../home24/helpers/storage-factory';
import * as baseTracking from '../../../home24-shared/core/base-tracking';

/**
 * tracking of forgot password events
 */

var eventNamespace = '.tracking';

const forgotPassword = _.extend({

    init: function () {
        $('.js-forgot-password').on(this.getEventName('click'), _.bind(this.onForgotPasswordClicked, this));

        $('#lightbox')
            .on(this.getEventName('click'), '.js-back-button', _.bind(this.onBackButtonClicked, this))
            .on(this.getEventName('submit'), '.js-forgot-password-form', _.bind(this.onForgotPasswordSubmitted, this));

        $.subscribe('closed.lightbox', $.proxy(this.onPopupClosed, this));

        return this;
    },

    getEventName: function (name) {
        return name + eventNamespace;
    },

    destroy: function () {
        $('#lightbox').off(eventNamespace);
        $('.js-forgot-password').off(eventNamespace);
        $.unsubscribe('closed.lightbox');
        this.closedByBackButton = false;
    },

    cookieCallbacks: {
        GtmOnForgotPassword: 'afterEmailChecked'
    },

    /**
     * flag explains that forgot password popup was closed by click on back button(Zurück)
     */
    closedByBackButton: false,

    setCookie: function (data) {
        getStorage().set('GtmOnForgotPassword', data);
    },

    onForgotPasswordClicked: function () {
        this.pushEvent({
            event: 'pass_forgotten_viewed'
        });
    },

    onForgotPasswordSubmitted: function () {
        this.setCookie({
            event: 'pass_forgotten_clicked',
            action: 'requested'
        });
    },

    onPopupClosed: function () {
        if (!this.closedByBackButton) {
            this.pushEvent({
                event: 'pass_forgotten_clicked',
                action: 'close'
            });
        }

        this.closedByBackButton = false;
    },

    onBackButtonClicked: function () {
        this.closedByBackButton = true;

        this.pushEvent({
            event: 'pass_forgotten_clicked',
            action: 'back'
        });
    },

    pushEvent: function (event) {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push(event);
        }
    },

    getServerResponse: function () {
        var $message = $('.messages').find('.error, .success');

        return $message.text();
    },

    afterEmailChecked: function (cookieValue) {
        var message = this.getServerResponse();

        if (message) {
            cookieValue.message = message;
            this.pushEvent(cookieValue);
        }
    }
}, baseTracking);

export function init() {
    return forgotPassword.init();
}

export function executeCookieCallbacks() {
    return forgotPassword.executeCookieCallbacks();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/login/forgotPassword.js
 **/